module.exports = __webpack_public_path__ + "img/antes_despues_88.eb7b648b.png";